import { Component } from '@angular/core';
import { FilemanagerComponent } from '../filemanagerpopup/filemanagerpopup.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
    selector: 'pw-fileexplorer',
    templateUrl: './fileexplorer.component.html',
    styleUrls: ['./fileexplorer.component.scss']
})
export class FileexplorerComponent {

    isExtraSmall: Observable<BreakpointState>;

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    constructor(private _matDialog: MatDialog,
        private readonly breakpointObserver: BreakpointObserver) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);

    }
    openFileManagerPopup() {
        const popupDialog = this._matDialog.open(FilemanagerComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size: any) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });
    }

}
